/**
 * Sonidos de notificación Hola Taxi.
 * Fuentes: resources/holataxi/audio/ → static/audio, android/res/raw, ios/App/App/*.caf
 */

export const HOLATAXI_SOUNDS = {
    VIAJES: 'holataxi_viajes',
    MENSAJES: 'holataxi_mensajes',
    CANCELAR: 'holataxi_cancelar',
    SINGPS: 'holataxi_singps',
    GENERICO: 'holataxi_generico'
};

/** @deprecated usar HOLATAXI_SOUNDS; compatibilidad con código que importaba APP_NOTIFICATION_SOUND */
export const APP_NOTIFICATION_SOUND = HOLATAXI_SOUNDS.GENERICO;

export const ANDROID_NOTIFICATION_CHANNEL_DEFAULT = 'default_channel';
export const ANDROID_NOTIFICATION_CHANNEL_URGENT = 'urgent_offers';
export const ANDROID_NOTIFICATION_CHANNEL_MESSAGES = 'messages_channel';
export const ANDROID_NOTIFICATION_CHANNEL_CANCEL = 'cancel_channel';
export const ANDROID_NOTIFICATION_CHANNEL_SINGPS = 'gps_lost_channel';

const VIAJES_URLS = new Set(['ofrecidos', 'reserva-proxima']);
const MENSAJES_URLS = new Set(['nuevo-mensaje', 'nuevo-audio']);
const CANCELAR_URLS = new Set(['cancelar']);
const SINGPS_URLS = new Set(['driver_lost']);

const LEGACY_VIAJES = new Set(['taxi', 'claxon']);
const LEGACY_MENSAJES = new Set(['new_message', 'primer_mensaje']);
const LEGACY_CANCELAR = new Set(['cancel_pacman', 'cancel']);

/**
 * Resuelve el nombre base del sonido (sin extensión) según tipo de notificación.
 * @param {string} [legacySound]
 * @param {string} [url]
 * @returns {string}
 */
export function resolveNotificationSound (legacySound, url) {
    if (url) {
        if (VIAJES_URLS.has(url)) {
            return HOLATAXI_SOUNDS.VIAJES;
        }
        if (MENSAJES_URLS.has(url)) {
            return HOLATAXI_SOUNDS.MENSAJES;
        }
        if (CANCELAR_URLS.has(url)) {
            return HOLATAXI_SOUNDS.CANCELAR;
        }
        if (SINGPS_URLS.has(url)) {
            return HOLATAXI_SOUNDS.SINGPS;
        }
    }

    if (legacySound) {
        if (legacySound === HOLATAXI_SOUNDS.SINGPS) {
            return HOLATAXI_SOUNDS.SINGPS;
        }
        if (LEGACY_VIAJES.has(legacySound)) {
            return HOLATAXI_SOUNDS.VIAJES;
        }
        if (LEGACY_MENSAJES.has(legacySound)) {
            return HOLATAXI_SOUNDS.MENSAJES;
        }
        if (LEGACY_CANCELAR.has(legacySound)) {
            return HOLATAXI_SOUNDS.CANCELAR;
        }
    }

    return HOLATAXI_SOUNDS.GENERICO;
}

/** Alias para reproducción in-app (misma lógica que push). */
export function resolveInAppSound (legacySound, url) {
    return resolveNotificationSound(legacySound, url);
}

/** Extensión del archivo en static/audio y android/res/raw */
export function getSoundExtension (baseName) {
    return baseName === HOLATAXI_SOUNDS.GENERICO ? 'mp3' : 'wav';
}

/** Nombre del archivo en bundle iOS para APNS / Media plugin */
export function getIosNotificationSoundFile (baseName) {
    return `${baseName}.caf`;
}

/**
 * Normaliza payload de push (Capacitor / FCM) para que url y sound estén en la raíz.
 * @param {object} notification
 * @returns {object}
 */
export function normalizePushNotification (notification) {
    if (!notification) {
        return notification;
    }
    const data = notification.additionalData || notification.data || {};
    if (!notification.additionalData && Object.keys(data).length) {
        notification.additionalData = data;
    }
    notification.url = notification.url || data.url || null;
    notification.sound = notification.sound || data.sound || null;
    notification.viaje_id = notification.viaje_id || data.viaje_id || null;
    return notification;
}

/** Canal Android según url de la notificación */
export function resolveAndroidNotificationChannel (url) {
    if (VIAJES_URLS.has(url)) {
        return ANDROID_NOTIFICATION_CHANNEL_URGENT;
    }
    if (MENSAJES_URLS.has(url)) {
        return ANDROID_NOTIFICATION_CHANNEL_MESSAGES;
    }
    if (CANCELAR_URLS.has(url)) {
        return ANDROID_NOTIFICATION_CHANNEL_CANCEL;
    }
    if (SINGPS_URLS.has(url)) {
        return ANDROID_NOTIFICATION_CHANNEL_SINGPS;
    }
    return ANDROID_NOTIFICATION_CHANNEL_DEFAULT;
}



// WEBPACK FOOTER //
// ./src/config/notificationSound.js